import { merge } from 'lodash';
import buildOptionalInsuranceEntryParams from 'src/components/Insurance/utils/buildOptionalInsuranceEntryParams';

export default function buildMedicalInsuranceParams({
  values,
  contactId,
  groupId,
  insuranceId,
}) {
  let medicalInsuranceParams = {
    group_id: groupId,
    data: {
      attributes: {
        external_member_id: values.insurance.member_id,
      },
      relationships: {
        person: {
          data: {
            id: contactId,
            type: 'person',
          },
        },
        plan: {
          data: {
            id: values.insurance.plan,
            type: 'plan',
          },
        },
      },
    },
  };

  if (insuranceId) {
    medicalInsuranceParams = { ...medicalInsuranceParams, id: insuranceId };
  }

  const optionalParams = buildOptionalInsuranceEntryParams(values);
  const paymentsFormParams = merge(medicalInsuranceParams, optionalParams);
  return paymentsFormParams;
}
